import * as React from "react";
const SvgFilterList = (props) => (
  <svg 
    width="1em"
    height="1em"
    fill="none" viewBox="0 0 18 12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
  <path 
    fill={props.fill || "currentColor"}
    d="M8 12C7.71667 12 7.47917 11.9042 7.2875 11.7125C7.09583 11.5208 7 11.2833 7 11C7 10.7167 7.09583 10.4792 7.2875 10.2875C7.47917 10.0958 7.71667 10 8 10H10C10.2833 10 10.5208 10.0958 10.7125 10.2875C10.9042 10.4792 11 10.7167 11 11C11 11.2833 10.9042 11.5208 10.7125 11.7125C10.5208 11.9042 10.2833 12 10 12H8ZM4 7C3.71667 7 3.47917 6.90417 3.2875 6.7125C3.09583 6.52083 3 6.28333 3 6C3 5.71667 3.09583 5.47917 3.2875 5.2875C3.47917 5.09583 3.71667 5 4 5H14C14.2833 5 14.5208 5.09583 14.7125 5.2875C14.9042 5.47917 15 5.71667 15 6C15 6.28333 14.9042 6.52083 14.7125 6.7125C14.5208 6.90417 14.2833 7 14 7H4ZM1 2C0.716667 2 0.479167 1.90417 0.2875 1.7125C0.0958333 1.52083 0 1.28333 0 1C0 0.716667 0.0958333 0.479167 0.2875 0.2875C0.479167 0.0958333 0.716667 0 1 0H17C17.2833 0 17.5208 0.0958333 17.7125 0.2875C17.9042 0.479167 18 0.716667 18 1C18 1.28333 17.9042 1.52083 17.7125 1.7125C17.5208 1.90417 17.2833 2 17 2H1Z"/>
  </svg>

);
export default SvgFilterList;
